import { useMemo } from 'react';
import { useAppSelector } from 'store/hooks';
import {
  selectMediaDevicePermissions,
  selectMediaDeviceByKind,
} from 'features/user-media/userMediaSlice';
import { OptionType } from 'components/Select';
import { useTranslation } from 'react-i18next';

export const useAudioInputField = () => {
  const { t } = useTranslation('settings');
  const mediaDevices = useAppSelector((state) => selectMediaDeviceByKind(state, 'audioinput'));
  const mediaDevicePermissions = useAppSelector((state) =>
    selectMediaDevicePermissions(state, 'audioinput')
  );

  const getPlaceholder = () => {
    if (mediaDevicePermissions === 'not-found') {
      return t('device_dropdowns.audioinput.placeholder_device_not_found');
    }

    if (mediaDevicePermissions === 'denied') {
      return t('device_dropdowns.audioinput.placeholder_permissions_denied');
    }

    return undefined;
  };

  const audioInputOptions = useMemo((): OptionType[] => {
    if (mediaDevicePermissions !== 'granted' || !mediaDevices.length) {
      return [];
    }

    return mediaDevices.map((device) => ({ value: device.deviceId, label: device.label }));
  }, [mediaDevices, mediaDevicePermissions]);

  return {
    audioInputOptions,
    audioInputPlaceholder: getPlaceholder(),
  };
};
